import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Search = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.9847 15.7845L21.2002 21M17.9517 10.3758C17.9517 14.4493 14.6495 17.7515 10.576 17.7515C6.50244 17.7515 3.2002 14.4493 3.2002 10.3758C3.2002 6.30224 6.50244 3 10.576 3C14.6495 3 17.9517 6.30224 17.9517 10.3758Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
